import { isEmpty } from 'es-toolkit/compat';

export const isNotEmpty = (args: Parameters<typeof isEmpty>[0]) =>
  !isEmpty(args);
